<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-reaname-member-class-school" @hidden="resetModal">
            <div class="container wrap-form-edit-comment-electronic-lecture">
                <h4>
                    <strong>Sửa bình luận</strong>
                </h4>
                <b-form id="form-edit-comment-electronic-lecture" @submit.prevent="handleSave">
                    <div class="login-modal__form__item display-block">
                        <label for="name">Sửa bình luận:</label>
                        <b-form-input id="name" v-model="form.content" type="text" placeholder="Nhập nội dung bình luận"
                            autocomplete="off"
                            class="form-control display-flex-center form-30h form-bg-gray-light border-rd-20 font-sanpro-light" />
                        <span class="error display-block color-err font-size-14 text-left"
                            v-if="!$v.form.content.required && submitted">
                            Vui lòng nhập nội dung bình luận
                        </span>

                    </div>
                    <div class="form_action display-flex justity-content-space-around">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading">
                            Cập nhật
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import {saveLessonCommentClassSchool} from './../../../_api/lessonCommentClassSchoolServices'
export default {
    name: "ModalChangeNameMemberClassSchool",
    props: {
        item: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    components: {
       
    },
    // watch: {
    //     classSchoolId(newval) {
    //         console.log(newval)
    //         if (newval > 0) {
    //             this.getDetailClassSchool()
    //         }
    //     }
    // },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,
            form: {
                id:0,
                content: '',
            }
        }
    },
    validations() {
        return {
            form: {
                content: {
                    required,
                },
                
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },

    },
    mounted() {
        this.form.id = this.item.id
        this.form.content = this.item.content
        this.handleShowModal()
    },

    methods: {
        
        
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        handleSave() {
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
                saveLessonCommentClassSchool(this.form).then((res)=>{
                    if (res && res.data && !res.errors) {
                        self.$toast.success('Sửa bình luận thành công thành công')
                        this.handleHideModal()
                        self.$emit('handleDone')
                    }
                })
            }
        },
        resetModal() {
            console.log('resetModal')
            this.submitted = false
            this.form = {
                content: '',
            }
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-reaname-member-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-reaname-member-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-reaname-member-class-school'].show()
        },
        
    }
}
</script>

<style lang="scss" scoped>

.wrap-form-edit-comment-electronic-lecture {
    padding-top: 20px;
    background-color: white;
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-around {
    justify-content: space-around
}
</style>